export default "__VITE_ASSET__ntU_Vy5G__"